import { Radio as RadioMantine } from '@mantine/core'
import React, { memo, useCallback } from 'react'

import Radio from '../../../../Mantine/Radio'

import * as S from './styles'

const RadioFilter = ({ nome, localFilters, setLocalFilters, opcoes }) => {
  const handleChange = useCallback(
    (value) => {
      setLocalFilters((prev) => ({ ...prev, [nome]: value }))
    },
    [setLocalFilters, nome]
  )

  return (
    <RadioMantine.Group
      name={nome}
      value={localFilters[nome] || 'todos'}
      onChange={handleChange}
    >
      <S.CheckboxAndRadioWrapper
        gridTemplateRows={Math.ceil((opcoes[nome] || []).length / 2)}
      >
        {opcoes[nome]?.map((opcao) => (
          <Radio key={opcao.value} value={opcao.value} label={opcao.label} />
        ))}
      </S.CheckboxAndRadioWrapper>
    </RadioMantine.Group>
  )
}

export default memo(RadioFilter)
